// Auth Types
export interface User {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: UserRole;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
}

export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  OPERATOR = 'OPERATOR',
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  access_token: string;
  user: User;
}

// Meeting Types
export interface Meeting {
  id: string;
  organizationId: string;
  contactId: string;
  productId: string;
  userId: string;
  status: MeetingStatus;
  startTime: string;
  endTime: string;
  duration: number;
  notes?: string;
  reminderSent: boolean;
  confirmedAt?: string;
  canceledAt?: string;
  completedAt?: string;
  createdAt: string;
  updatedAt: string;

  // Relations
  contact?: Contact;
  product?: Product;
  user?: User;
}

export enum MeetingStatus {
  SCHEDULED = 'scheduled',
  CONFIRMED = 'confirmed',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  NO_SHOW = 'no_show',
}

export interface Contact {
  id: string;
  name: string;
  phone: string;
  email?: string;
  organizationId: string;
  tags?: string[];
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface Product {
  id: string;
  name: string;
  description?: string;
  keywords?: string[];
  organizationId: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// API Response Types
export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
}

export interface ApiError {
  statusCode: number;
  message: string;
  error?: string;
}

// Meeting Filters
export interface MeetingFilters {
  status?: MeetingStatus;
  startDate?: string;
  endDate?: string;
  userId?: string;
  productId?: string;
  page?: number;
  limit?: number;
}

// WebSocket Events
export interface SocketEvent {
  type: string;
  data: any;
}

export interface MeetingUpdatedEvent {
  meeting: Meeting;
}

export interface NotificationEvent {
  title: string;
  body: string;
  data?: Record<string, any>;
}
